/**
 * BrandToast — DS confirm-toast tokens.
 *
 * Source: docs/agapella-design-system/project/preview/components-toast.html
 * (confirm variant). Obsidian background + white text + green checkmark halo.
 *
 * Solar is reserved for brand-attention (CTAs, active states, the agapē mark)
 * — never for confirm feedback. Confirm reads as obsidian; error reads as red.
 */

export const brandToastConfirmTokens = {
  background: '#00121D',
  textColor: '#FFFFFF',
  borderColor: 'rgba(255,255,255,0.06)',
  iconHaloBackground: 'rgba(34, 197, 94, 0.20)',
  iconColor: '#22C55E',
  iconHaloSize: 24,
  iconSize: 14,
  borderRadius: 100,
  shadow: {
    web: '0 12px 30px rgba(0,18,29,0.20)',
    native: {
      color: '#00121D',
      offset: { width: 0, height: 8 },
      opacity: 0.20,
      radius: 16,
      elevation: 8,
    },
  },
} as const;

export type BrandToastConfirmTokens = typeof brandToastConfirmTokens;
